function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.3913 9C2.07083 9 1 10.0702 1 11.39C1 12.7098 2.07083 13.78 3.3913 13.78C4.71178 13.78 5.78261 12.7098 5.78261 11.39C5.78261 10.0702 4.71178 9 3.3913 9ZM12 9C10.6795 9 9.6087 10.0702 9.6087 11.39C9.6087 12.7098 10.6795 13.78 12 13.78C13.3205 13.78 14.3913 12.7098 14.3913 11.39C14.3913 10.0702 13.3205 9 12 9ZM18.2174 11.39C18.2174 10.0702 19.2882 9 20.6087 9C21.9292 9 23 10.0702 23 11.39C23 12.7098 21.9292 13.78 20.6087 13.78C19.2882 13.78 18.2174 12.7098 18.2174 11.39Z",
  fill: "#F29025"
});

var SvgPayment = function SvgPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment.dc620df9.svg";
export { ForwardRef as ReactComponent };